import $ from 'jquery';
import plugin from '@core/plugins/lib';
import { onAvailable } from "@core/plugins/lib/selectors";


export const ELEMENT_SELECTOR = '[data-toggle-element-classes]';
export const PLUGIN_NAME = 'ToggleElementClasses';


$(() => {
	onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		System.import(
			/* webpackChunkName: "plugin--toggle-element-classes" */ './plugin.js'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__toggle-element-classes/index.js